import { InjectionToken } from '@angular/core';
import { FooterLink } from 'src/shared/models/footer-link';

export const FOOTER_LINKS = new InjectionToken<FooterLink[]>('FOOTER_LINKS');
